<div class='wrapperBtnAndLine'
     [style]='{width: w+"px", maxWidth: w+"px", minWidth: w+"px"}'>
  <div class='wrapperBtnAndLine__lineLeft' [style]='{bcg:colorLine}|getStyles'></div>
  <btn [disabled]="disabled" [text]='text' [bcg]='bcg' (click)='emit.emit()'></btn>
  <div class='wrapperBtnAndLine__lineRight' [style]='{bcg:colorLine}|getStyles'></div>
</div>